<template>
  <div class="wrap">
    <ImmersionHeader
      ref="ImmersionHeader"
      uiTheme="globalOne"
      :isShowBackBtn="true"
      leftIconClassName="icon-v3_outlined_back"
      :blackTheme="false"
      @BackCK="goBackFn"
    />
    <template v-if="initLoading">
      <LoadingMask />
    </template>
    <template v-else>
      <template v-if="isLogin">
        <LoadingMask v-if="loading" />
        <template v-else>
          <div class="box" :class="{ pb300: spotifyUrl }">
            <img :src="imageUrl" class="imgStyle" />
            <div v-if="spotifyUrl" class="buttomBox">
              <div class="title">{{ $t('FoodC_landingpage_dTIE_JZwU') }}</div>
              <div class="urlBox">
                <div class="url">{{ spotifyUrl }}</div>
                <div class="btn">
                  <go-button size="medium" @click="ckCopyUrl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style="width: 1em; height: 1em; vertical-align: middle"
                      overflow="hidden"
                      viewBox="0 0 48 48"
                    >
                      <path
                        d="M15.256 12l8.876.001.373.005.706.017c2.604.09 4.097.457 5.64 1.282a9.269 9.269 0 0 1 3.844 3.844c.718 1.342 1.088 2.645 1.232 4.675l.037.632.023.68.007.359.006.76v8.49l-.006.76a39.58 39.58 0 0 1-.007.36l-.023.68-.037.63c-.144 2.03-.514 3.334-1.232 4.676a9.269 9.269 0 0 1-3.844 3.844c-1.409.753-2.776 1.124-4.985 1.252l-.655.03c-.227.008-.462.014-.706.017l-.76.006h-8.49l-.76-.006c-.244-.003-.479-.01-.706-.017l-.655-.03c-2.21-.128-3.576-.499-4.985-1.252a9.269 9.269 0 0 1-3.844-3.844c-.718-1.342-1.088-2.645-1.232-4.675l-.037-.632-.023-.68a39.58 39.58 0 0 1-.007-.359L3 32.745l.001-8.877c.002-.253.006-.497.012-.732l.023-.68.037-.632c.144-2.03.514-3.333 1.232-4.675a9.269 9.269 0 0 1 3.844-3.844c1.543-.825 3.036-1.191 5.64-1.282l.706-.017c.244-.004.497-.006.76-.006zm8.82 4.001h-9.153c-.108 0-.213.002-.316.003l-.59.012-.534.02-.484.03c-1.153.087-1.888.265-2.563.569l-.267.128-.133.07a5.27 5.27 0 0 0-2.204 2.203 5.9 5.9 0 0 0-.647 1.936l-.055.382c-.025.2-.046.414-.063.645l-.03.484a24.1 24.1 0 0 0-.012.26l-.016.562-.008.618v9.154l.008.618.007.287.02.535.03.484c.018.23.039.445.064.645l.055.382c.09.549.218.99.39 1.4l.122.27c.043.09.088.178.135.266a5.27 5.27 0 0 0 2.204 2.204c.088.047.177.092.266.135l.27.122c.639.267 1.35.427 2.427.508l.484.03.535.021.287.007.618.008 8.821.001.65-.004.588-.012.535-.02.484-.03c1.077-.082 1.788-.242 2.427-.51l.27-.121c.09-.043.178-.088.266-.135a5.27 5.27 0 0 0 2.204-2.204 7.38 7.38 0 0 0 .135-.266l.122-.27c.172-.41.3-.851.39-1.4l.055-.382c.025-.2.046-.414.063-.645l.03-.484a24.1 24.1 0 0 0 .012-.26l.016-.562.008-.618v-9.154l-.008-.618a33.28 33.28 0 0 0-.007-.287l-.02-.535-.03-.484c-.018-.23-.039-.445-.064-.645l-.055-.382a5.9 5.9 0 0 0-.647-1.936 5.27 5.27 0 0 0-2.337-2.273l-.267-.128c-.675-.304-1.41-.482-2.563-.568l-.484-.03a24.1 24.1 0 0 0-.26-.012l-.562-.016-.618-.008zm7.88-12.354l.77.006.715.017c2.637.092 4.146.462 5.706 1.296a9.369 9.369 0 0 1 3.887 3.887c.798 1.492 1.171 2.938 1.282 5.369l.024.688.007.364.006.77v7.592l-.006.77-.007.364-.024.688c-.11 2.43-.484 3.876-1.282 5.369a9.45 9.45 0 0 1-1.652 2.234 2 2 0 1 1-2.829-2.828c.374-.374.692-.805.953-1.293.434-.812.673-1.607.78-3.013l.03-.492.011-.264.017-.57.008-.628v-8.267l-.008-.628-.017-.57-.025-.516c-.081-1.312-.265-2.113-.595-2.846l-.13-.272a5.37 5.37 0 0 0-2.316-2.38l-.27-.138c-.726-.348-1.493-.547-2.743-.641l-.492-.03a24.438 24.438 0 0 0-.265-.012l-.57-.017a40.244 40.244 0 0 0-.627-.008h-8.267l-.322.003-.598.012-.278.01-.516.025c-1.394.087-2.212.288-2.982.658l-.271.138c-.39.208-.744.454-1.062.735l-.23.218a2 2 0 0 1-2.83-2.829 9.45 9.45 0 0 1 2.235-1.652c1.56-.834 3.07-1.204 5.707-1.296l.714-.017.77-.006h7.592z"
                        fill="#ffffff"
                        class="svg-icon"
                      />
                    </svg>
                    <span class="btn_info">{{ $t('FoodC_landingpage_mibx_wmgS') }}</span>
                  </go-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <LogOut @update-login="updateLogin" />
      </template>
    </template>
  </div>
</template>

<script>
import { get } from 'lodash-es'
import '@/go-design-ui.js'
import apiConfig from '@/common/js/apiConfig'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import LoadingMask from '@/components/loading/loading-mask.vue'
import LogOut from '../components/logOut/index.vue'
import { apiGetSpotifyInfo } from '@/api/member/index.js'
import { copyUrl } from '../common/utils'
import {
  sailing_c_x_membership_spotifylanding_sw,
  sailing_c_x_membership_spotifylanding_ck,
} from '../trackEvent'

export default {
  name: 'SpotifyPage',
  components: {
    ImmersionHeader,
    LoadingMask,
    LogOut,
  },
  data() {
    return {
      initLoading: true,
      isLogin: false,
      loading: false,
      styleType: 0,
      imageUrl: '',
      spotifyUrl: '',
    }
  },
  created() {
    this.styleType = +this.params?.styleType || 0

    if (apiConfig.isDev) {
      this.initLoading = false
      this.isLogin = true
      this.init()
    } else {
      this.checkLogin()
    }
    sailing_c_x_membership_spotifylanding_sw({ type: this.styleType })
  },
  methods: {
    async init() {
      this.loading = true
      let res = {}
      try {
        res = await apiGetSpotifyInfo({ spotifyStyleType: this.styleType })
      } catch (err) {
        console.log('api err', err)
      }
      this.loading = false
      console.log('init api res', res)

      if (res.errno === 0) {
        this.imageUrl = res.data?.imageUrl || ''
        this.spotifyUrl = res.data?.spotifyUrl || ''
      } else {
        this.$createGoToast({
          text: res.errmsg,
          time: 1500,
          type: 'error',
        }).show()
      }
    },
    ckCopyUrl() {
      sailing_c_x_membership_spotifylanding_ck({ type: this.styleType })

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(this.spotifyUrl)
          .then(() => {
            console.log('navigator.clipboard success')
            this.showToast('success')
          })
          .catch(err => {
            console.error('降级===>>>', err)
            this.fallbackCopy()
          })
      } else {
        this.fallbackCopy()
      }
    },
    // 降级复制逻辑
    fallbackCopy() {
      copyUrl(this.spotifyUrl)
        .then(() => {
          this.showToast('success')
        })
        .catch(() => {
          this.showToast('error')
        })
    },
    showToast(type) {
      if (type === 'success') {
        this.$createGoToast({
          text: this.$t('FoodC_landingpage_WjPA_dhTE'),
          time: 1500,
          type: 'positive',
        }).show()
      }
      if (type === 'error') {
        this.$createGoToast({
          text: this.$t('FoodC_landingpage_hhPh_bwJS'),
          time: 1500,
          type: 'error',
        }).show()
      }
    },
    goBackFn() {
      this.SodaBridge('closePage')
    },
    // 校验登录
    checkLogin() {
      Soda.getUserInfo({}, async data => {
        this.initLoading = false
        if (data && get(data, 'data.token', '')) {
          this.isLogin = true
          this.init()
        } else {
          this.isLogin = false
        }
      })
    },
    updateLogin() {
      this.isLogin = true
      this.init()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.box {
  width: 100%;

  &.pb300 {
    padding-bottom: 300px;
  }
  .imgStyle {
    width: 100%;
  }
  .buttomBox {
    background-color: #fff;
    padding-bottom: 80px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    box-shadow: 0px -10px 80px 0px rgba(40, 70, 100, 0.08);
    .title {
      padding: 0 40px;
      padding-top: 40px;
      padding-bottom: 24px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      line-height: 36px;
      letter-spacing: normal;
      color: #3d3d3d;
    }
    .urlBox {
      margin: 0 32px;
      padding: 28px 20px;
      border-radius: 40px;
      background: #f5f5f7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .url {
        user-select: text;
        // flex-shrink: 0;
        // width: 380px;
        margin-right: 20px;
        font-family: DiDiSans-Pro-Regular;
        font-size: 28px;
        font-weight: normal;
        line-height: 36px;
        letter-spacing: normal;
        color: #0b0b0d;
        word-break: break-all;
        @include ellipsis(2);
      }
      .btn {
        flex: 1;
        max-width: 230px;
        .btn_info {
          margin-left: 16px;
        }
      }
    }
  }
}
</style>
